import SliderNews from './SliderNews';
export default SliderNews;
